// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@adl/App/Store/Reducers";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { hasChanges } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";

export function xHasChanges(state: CustomAppState) {
    const ootbHasChanges = hasChanges(state);
    const {
        userSetup: { userId, editingUser },
    } = state.pages;
    const user = getAccountState(state, userId).value;
    if (!user || !editingUser) {
        return false;
    }
    const customQuoteEnabled = `${!!state.xUserSetup.customQuoteEnabled}`;
    return ootbHasChanges || customQuoteEnabled !== user?.properties?.customQuoteEnabled;
}
